var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 789,
    height: 110,
    viewBox: "0 0 789 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.699 107.8H606.999V77.9L621.899 107.8H632.499L647.499 77.9V107.8H658.799V64H643.799L627.199 97.2L610.599 64H595.699V107.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.102 107.8H547.802L576.302 76.6V107.8H587.602V64H575.002L546.402 95.2V64H535.102V107.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.602 107.8H486.602L501.502 92.8L516.502 107.8H530.402L508.502 85.9L530.402 64H516.502L501.502 78.9L486.602 64H472.602L494.502 85.9L472.602 107.8Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.699 107.8H467.899V100.5H429.999V87.5H464.599V80.2H429.999V71.3H467.899V64H418.699V107.8Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.898 71.3H379.498V107.8H390.798V71.3H413.298V64H356.898V71.3Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.502 68.9004H326.902V63.9004H315.602V68.9004H307.002C299.002 68.9004 291.102 68.9004 291.102 77.9004V93.8004C291.102 102.8 299.102 102.8 307.002 102.8H315.602V107.8H326.902V102.8H335.502C343.502 102.8 351.402 102.8 351.402 93.8004V77.9004C351.502 68.9004 343.502 68.9004 335.502 68.9004ZM315.602 95.5004H306.302C304.302 95.5004 302.302 95.5004 302.302 93.2004V78.6004C302.302 76.3004 304.302 76.3004 306.302 76.3004H315.602V95.5004ZM336.202 95.5004H326.902V76.2004H336.202C338.202 76.2004 340.202 76.2004 340.202 78.5004V93.1004C340.202 95.5004 338.202 95.5004 336.202 95.5004Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.801 107.8H283.001V100.5H245.101V87.5H279.701V80.2H245.101V71.3H283.001V64H233.801V107.8Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.301 107.8H184.601V87.5H214.501V107.8H225.801V64H214.501V80.2H184.601V64H173.301V107.8Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M737.301 49.9992H748.601V43.3992L758.201 33.7993L774.501 49.9992H788.501L765.201 26.7993L785.801 6.19922H771.801L748.601 29.4992V6.19922H737.301V49.9992Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.102 41.1008C680.102 50.1008 688.102 50.1008 696.002 50.1008H729.202V42.8008H695.302C693.302 42.8008 691.302 42.8007 691.302 40.5007V15.9008C691.302 13.6008 693.302 13.6008 695.302 13.6008H729.202V6.30078H696.002C688.002 6.30078 680.102 6.30078 680.102 15.3008V41.1008Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M609 49.9992H620.2V20.1992L635.2 49.9992H645.8L660.8 20.1992V49.9992H672V6.19922H657.1L640.5 39.3992L623.9 6.19922H609V49.9992Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.302 6.19922H567.002L545.102 49.9992H557.102L563.402 37.3992H586.002L592.302 49.9992H604.302L582.302 6.19922ZM567.002 30.0992L574.602 14.7993L582.202 30.0992H567.002Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M492.602 49.9992H503.802V43.3992L513.502 33.7993L529.702 49.9992H543.702L520.402 26.7993L541.002 6.19922H527.102L503.802 29.4992V6.19922H492.602V49.9992Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.301 49.9992H484.501V42.6992H446.601V29.7993H481.201V22.4992H446.601V13.4992H484.501V6.19922H435.301V49.9992Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.801 49.9992H386.101V29.7993H416.001V49.9992H427.301V6.19922H416.001V22.4992H386.101V6.19922H374.801V49.9992Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291 49.9992H305L321.3 33.7993L324.9 37.3992V49.9992H336.2V37.3992L339.9 33.7993L356.1 49.9992H370.1L346.8 26.7993L367.4 6.19922H353.5L336.2 23.4992V6.19922H324.9V23.4992L307.7 6.19922H293.7L314.3 26.7993L291 49.9992Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.801 49.9992H246.501L275.001 18.7993V49.9992H286.301V6.19922H273.701L245.101 37.3992V6.19922H233.801V49.9992Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.301 49.9992H184.601V29.7993H214.501V49.9992H225.801V6.19922H214.501V22.4992H184.601V6.19922H173.301V49.9992Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6 57.801C78.9 51.101 65.3 48.401 52 50.301V50.401C52.4 54.701 53.1 58.901 54.2 63.001V63.101C64.6 61.701 74.9 63.801 84 69.101C94 74.901 101.5 84.101 105.2 95.001L105.4 95.501L104.9 95.601C94.3 97.701 83.3 96.201 73.7 91.201L73.6 91.401C70.9 94.801 67.6 97.901 63.8 100.601C64.3 100.901 64.9 101.201 65.4 101.601C82.2 111.301 102.8 112.301 120.6 104.301C118.6 84.801 107.4 67.501 90.6 57.801Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 0C44.4 11.4 35 29.7 35 49.1C35 62.6 39.5 75.7 47.8 86.3L47.9 86.2C49.1 85.5 50.7 84.4 53.6 82C54.9 80.8 56.2 79.6 57.5 78.2L57.8 77.9C51.4 69.6 48.1 59.6 48.1 49.1C48.1 37.6 52.3 26.4 59.9 17.8L60.3 17.4L60.7 17.8C67.9 25.9 72 36.2 72.5 47L72.8 47.1C74.4 47.4 76.4 47.9 80.3 49.1C82.1 49.7 83.8 50.4 85.5 51.1C85.5 50.5 85.5 49.8 85.5 49.2C85.5 29.7 76.1 11.4 60.2 0Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9 71.8004C79.6 71.1004 78 70.3004 74.4 68.9004C72.7 68.3004 71 67.9004 69.1 67.5004L68.7 67.4004C64.7 77.1004 57.8 85.0004 48.6 90.2004C38.6 96.0004 26.9 97.9004 15.5 95.6004L15 95.5004L15.2 95.0004C18.7 84.7004 25.5 76.0004 34.6 70.2004L34.5 69.9004C34 68.3004 33.4 66.4004 32.4 62.4004C32 60.6004 31.7 58.7004 31.5 56.9004C31 57.2004 30.4 57.5004 29.9 57.8004C13.1 67.5004 1.9 84.9004 0 104.2C17.7 112.2 38.3 111.2 55.2 101.5C66.9 94.8004 76 84.3004 81 71.8004H80.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/Нижнекамск нефтехим.e103cd8d11f61ef54bd5c25affb534d1.svg";
export { ForwardRef as ReactComponent };